import { render } from "./AdminBulkContributions.vue?vue&type=template&id=76bde39e&scoped=true"
import script from "./AdminBulkContributions.vue?vue&type=script&lang=js"
export * from "./AdminBulkContributions.vue?vue&type=script&lang=js"

import "./AdminBulkContributions.vue?vue&type=style&index=0&id=76bde39e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76bde39e"]])

export default __exports__